// Files stay in the native multipart product form; Shopify stores them as line item properties.
(function () {
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    var inputs = Array.from(root.querySelectorAll('[data-pet-photo-input]'));
    var status = root.querySelector('[data-pet-photo-status]');
    inputs.forEach(function (input) {
      var slot = input.closest('[data-pet-photo-slot]');
      var preview = slot.querySelector('[data-pet-photo-preview]');
      var empty = slot.querySelector('[data-pet-photo-empty]');
      var remove = slot.querySelector('[data-pet-photo-remove]');
      var error = slot.querySelector('[data-pet-photo-error]');
      var objectUrl;
      input.addEventListener('change', function () {
        if (objectUrl) URL.revokeObjectURL(objectUrl);
        preview.hidden = true;
        preview.removeAttribute('src');
        error.textContent = '';
        empty.textContent = 'Choose a photo';
        var file = input.files[0];
        if (file && (!['image/jpeg', 'image/png', 'image/webp'].includes(file.type) || !file.size || file.size > 10 * 1024 * 1024)) {
          error.textContent = 'Choose a JPG, PNG or WebP image up to 10 MB. You can also leave this photo empty.';
          input.value = '';
          file = null;
        }
        if (file) {
          objectUrl = URL.createObjectURL(file);
          preview.src = objectUrl;
          preview.hidden = false;
        }
        slot.classList.toggle('has-photo', !!file);
        slot.querySelector('[data-pet-photo-action]').textContent = file ? 'Change photo' : 'Upload photo ＋';
        empty.hidden = !!file;
        remove.hidden = !file;
        var count = inputs.filter(function (field) { return field.files.length > 0; }).length;
        status.textContent = count + ' of 3 photos selected. ' + (count ? 'Photos will be uploaded when you add this item to your cart or buy it now.' : 'You can order without photos.');
      });
      remove.addEventListener('click', function () {
        input.value = '';
        input.dispatchEvent(new Event('change', { bubbles: true }));
        input.focus();
      });
      preview.addEventListener('error', function () {
        preview.hidden = true;
        empty.hidden = false;
        empty.textContent = 'Preview unavailable. File selected.';
      });
    });
    var form = root.closest('form');
    form.addEventListener('submit', function (event) {
      if (form.dataset.photosSubmitting === 'true') {
        event.preventDefault();
        return;
      }
      form.dataset.photosSubmitting = 'true';
      status.textContent = 'Saving your item and any selected photos. Please keep this page open…';
      // Keep submitter enabled: disabling it would lose Buy It Now's return_to value.
      form.querySelectorAll('.purchase-actions button').forEach(function (button) { button.setAttribute('aria-disabled', 'true'); });
    });
    window.addEventListener('pageshow', function () {
      delete form.dataset.photosSubmitting;
      form.querySelectorAll('.purchase-actions button').forEach(function (button) { button.removeAttribute('aria-disabled'); });
      inputs.forEach(function (input) { input.dispatchEvent(new Event('change')); });
    });
  }
  function initAll() { document.querySelectorAll('[data-pet-order-photos]').forEach(init); }
  initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
